Controller.$inject = [];

function Controller() {

}

export function HuiStepButton() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            stepNumber: '<',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-step-button">
                    <div class="hui-step-indicator">
                        <span>{{$huiCtrl.stepNumber}}</span>
                    </div>
                </div>
            `;
        }
    }
}